function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import TrackerContext from "./Context";
export function withTracker(Component) {
  function WithTrackerComponent(props) {
    return /*#__PURE__*/React.createElement(TrackerContext.Consumer, null, state => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      tracker: state
    })));
  }

  hoistNonReactStatic(WithTrackerComponent, Component);
  return WithTrackerComponent;
}
/**
 * @deprecated since version 1.0.0
 */

export const withTrackerContext = withTracker;